import { Icon } from '@progress/kendo-react-common'
import React from 'react'
import { Row, Col, Card } from 'reactstrap'
import { Btn } from '../../../AbstractElements'
import { orderByVendorCode } from '../../../_helper/helper'
import { RetireeDentalCompanyArray as companyArray } from '../../../_helper/helper'
import NewEmployeeDetails from '../../CoverageChange/Components/NewEmployeeDetails'

const ActiveHealthAndDeductionPlan = (props) => {
  const { renderGroupCheckbox, selfData } = props

  // Sorting function

  return (
    <Card style={{ padding: "20px" }}>
      {/* <Row>
        <Col md={3}><b style={{ fontSize: "18px" }}>Health Plan Choice</b></Col>
        {healthPlamArray?.map((item) => {
          return (
            <>
              <Col md={3}>
                <div style={{ display: "flex" }}>
                  <div>{renderCheckbox("large",item.key , item.title)}</div> <div style={{ alignSelf: "center" }}> <b style={{ fontSize: "15px", alignItems: "center" }}>{item.title}</b>
                    <div>{item.text}</div></div>
                </div>
              </Col>
            </>
          )
        })}
      </Row> */}

      <NewEmployeeDetails data={selfData} />
      <Row>

        {orderByVendorCode(companyArray).map((item, ind) => {
          return <Col md={6} className='p-2' key={ind}>
            <Card className='rounded' style={{ margin: '10px', marginBottom: '15px' }}>
              <table className=' ' style={{ width: "100%" }}>
                <tr style={{ margin: "10px" }}>
                  {/* <td> */}
                  <th colSpan={6} className='p-2 bg-primary text-white rounded-top'>{item.vendor_name}</th>
                  {/* </td> */}
                </tr>


                {item?.vendor_items?.length ? item.vendor_items.map((i, index) => {
                  return (
                    <tr style={{ cursor: "pointer", backgroundColor: '#ffe4c4', padding: "5px" }} key={index}
                    // onClick={(e) => {
                    //   setValues({ ...values, HealthVendor: item?.vendor_name, healthPlan: i.vendor_code })
                    // }}
                    >
                      <td>
                        {renderGroupCheckbox("medium", 'dentalPlan', i.vendor_code, { matchkey: 'dentalVendor', matchvalue: item?.vendor_name })}

                      </td>
                      <td colSpan={5} style={{ width: "80px" }}>
                        <b>{i.vendor_code}</b>
                      </td>
                      {/* <td></td>
                      <td> <b>Total</b> </td>
                      <td> <b>Gov.</b> </td>
                      <td> <b>Emp.</b> </td> */}

                    </tr>
                  )
                }) : null}
                <tr>
                  {/* <tr style={{ cursor: "pointer", backgroundColor: index % 2 ? "#e6e6e6" : "", padding: "5px" }}> */}

                  <td>

                  </td>
                  <td>
                  </td>
                  <td style={{ width: "200px" }}> </td>
                  <td style={{ borderLeft: "1px solid #d2d2d2", fontWeight: "600" }}>Emp</td>
                  <td style={{ borderLeft: "1px solid #d2d2d2", fontWeight: "600" }}>Govt</td>
                  <td style={{ borderLeft: "1px solid #d2d2d2", fontWeight: "600" }}>Total</td>
                  {/* <td><div style={{ marginTop: "8px" }}>{k.label} {k.govRate ? `$${k.govRate}` : ''} <b>({`+ $${k.empRate}`})</b></div></td> */}

                  {/* </tr> */}
                </tr>
                {item?.vendor_items?.length ? item.vendor_items.map((i, index) => {
                  return (
                    <>
                      {i?.classInfo.map((k) => {
                        return (
                          <tr>
                            {/* <tr style={{ cursor: "pointer", backgroundColor: index % 2 ? "#e6e6e6" : "", padding: "5px" }}> */}

                            <td>
                              <div style={{ width: '40px' }}>
                                {renderGroupCheckbox("small", k.key, k.value, { disabled: true, changeTarget1: 'dentalVendor', changeTargetValue1: item?.vendor_name, changeTarget2: 'dentalPlan', changeTargetValue2: i.vendor_code, matchkey: 'dentalVendor', matchvalue: item?.vendor_name, matchkey1: 'dentalPlan', matchvalue1: i.vendor_code })}
                              </div>
                            </td>
                            <td>
                              <b style={{ alignSelf: "center" }}>{k.className}</b></td>
                            {/* <td><div style={{ marginTop: "8px" }}>{k.label} {k.amount ? `$${k.amount}` : ''} <b>({`$${k.rate}`})</b></div></td> --old */}
                            <td style={{ width: "200px" }}>{k.label}</td>
                            {/* <td><div style={{ marginTop: "8px" }}>{k.amount ? `$${k.amount}` : ''} </div></td> */}
                            <td style={{ borderLeft: "1px solid #d2d2d2" }}>{`$${k.empRate}`}</td>
                            <td style={{ borderLeft: "1px solid #d2d2d2" }}>{`$${k.govRate}`}</td>
                            <td style={{ borderLeft: "1px solid #d2d2d2" }}>{`$${k.amount}`}</td>
                            {/* <td><div style={{ marginTop: "8px" }}>{k.label} {k.govRate ? `$${k.govRate}` : ''} <b>({`+ $${k.empRate}`})</b></div></td> */}

                            {/* </tr> */}
                          </tr>
                        )
                      })}
                    </>
                  )
                }) : null}



              </table>
            </Card>
          </Col>
        })}


        {/* {
            i?.classInfo.map((k) => {
              return <tr style={{ cursor: "pointer", backgroundColor: index % 2 ? "#e6e6e6" : "", padding: "5px" }}>
              <div style={{ display: "flex" }}>
                <td><div style={{ width: '140px' }}>{renderGroupCheckbox("small", k.key, k.value, { disabled: true, changeTarget1: 'HealthVendor', changeTargetValue1: item?.vendor_name, changeTarget2: 'healthPlan', changeTargetValue2: i.vendor_code, matchkey: 'HealthVendor', matchvalue: item?.vendor_name, matchkey1: 'healthPlan', matchvalue1: i.vendor_code })}  <b style={{ alignSelf: "center" }}>{k.className}</b></div></td>
                <td><div style={{ marginTop: "8px" }}>{k.label} {k.amount ? `$${k.amount}` : ''} <b>({`$${k.empRate}`})</b></div></td>
                <td><div style={{ marginTop: "8px" }}>{k.label} {k.govRate ? `$${k.govRate}` : ''} <b>({`+ $${k.empRate}`})</b></div></td>
              </div></tr>
            })
          } */}

      </Row>

      {/* <Row className='mt-2'>
        <Col md={"auto"}>
          <Btn
            attrBtn={{
              color: "primary",
              style: { width: "100%" },
              onClick: () => { handleUpdatePlan() },
            }}
          >
            <Icon style={{ fontSize: '18px' }} name="save" /> &nbsp; Update Plan
          </Btn>
        </Col>
      </Row> */}
    </Card>
  )
}

export default ActiveHealthAndDeductionPlan